import { getGraphqlClient } from "@/api/graphql/client.ts";
import { GetNotificationsByAccountQuery } from "@/api/graphql/notifications/account/queries.ts";
import { NOTIFICATIONS_PER_PAGE } from "@/api/graphql/notifications/constants.ts";
import { mapNotificationsPageFromGraphQLForAccount } from "@/api/graphql/notifications/mappers.ts";
import type {
  GetNotificationsRequest,
  NotificationsPageBO,
} from "@/api/graphql/notifications/types.ts";
import { createEmptyNotificationsPage } from "@/api/graphql/notifications/types.ts";
import type { GetNotificationsByAccountQueryQuery } from "@/api/graphql/types/graphql.ts";

export const getNotificationsByAccount = async ({
  filters,
  paging,
  sorts,
}: GetNotificationsRequest): Promise<NotificationsPageBO> => {
  const page = paging?.page || 1;
  const size = paging?.size || NOTIFICATIONS_PER_PAGE;

  const response =
    await getGraphqlClient().request<GetNotificationsByAccountQueryQuery>(
      GetNotificationsByAccountQuery,
      {
        request: {
          filters,
          paging: {
            page,
            size,
          },
          sorts,
        },
      },
    );

  return (
    mapNotificationsPageFromGraphQLForAccount(
      response.NotificationsMsSearchNotifications,
    ) ?? {
      ...createEmptyNotificationsPage(page, size),
    }
  );
};
